import { BaseCallState } from '../../../../platform-call';
import {
    CallHandle,
    callHandleActive,
    CallState,
    CallStatusNotification,
    HubMethods,
} from '../../../../teams-call';
import { HandleSocketMessageFns } from '../model/handle-socket-message-fns.model';

interface Msg {
    hubMethod: string;
    payload: any;
}

export function handleTeamsCallSocketMessage(
    msg: Msg,
    fns: HandleSocketMessageFns,
): void {
    switch (msg.hubMethod) {
        case HubMethods.OnCurrentCall:
            onCurrentCall(msg.payload, fns);
            break;
        case HubMethods.OnCallStatus:
            onCallStatus(msg.payload, fns);
            break;
    }
}

export function onCurrentCall(
    payload: CallHandle | null,
    fns: HandleSocketMessageFns,
): void {
    if (callHandleActive(payload)) {
        fns._meetingStarted();
        const initialTranscriptState = payload?.stateHistory?.find(
            (e) => e.state === CallState.InitialTranscriptStreamed,
        );
        if (initialTranscriptState != null) {
            fns._initialTranscriptStreamed();
        }
    } else {
        // fns._meetingEnded();
    }
}

export function onCallStatus(
    payload: CallStatusNotification | null,
    fns: HandleSocketMessageFns,
): void {
    if (
        fns._callHandleId() == null ||
        payload?.callHandleId !== fns._callHandleId()
    ) {
        return;
    }

    fns._rememberStatusChange(payload.status);
    switch (payload.status) {
        case BaseCallState.Started:
            fns._reset();
            break;
        case CallState.MeetingStarted:
            fns._meetingStarted();
            break;
        case CallState.InitialTranscriptStreamed:
            fns._initialTranscriptStreamed();
            break;
        case CallState.MeetingEnded:
        case BaseCallState.Ended:
            fns._meetingEnded();
            break;
    }
}
